export default __webpack_public_path__ + "static/media/Datorsal4.9837c2e2.jpeg";